import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children
}) => {
  const {
    isOnboardingComplete
  } = useUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isOnboardingComplete) {
      navigate('/onboarding');
    }
  }, [isOnboardingComplete, navigate]);
  if (!isOnboardingComplete) {
    return <Navigate to="/onboarding" replace data-id="element-82" />;
  }
  return <>{children}</>;
};
export default ProtectedRoute;